export default function () {

  $(document).on('ready', function(){
    $('.product-cats__category.has-child').click(function() {

      $( this ).next( '.product-cats__submenu' ).toggleClass('show-sub');
      $( this ).next( '.product-cats__submenu-submenu' ).toggleClass('show-sub');

      $( this ).delay(200).queue(function(){
        $(this).toggleClass('active').dequeue();
      });
      return false;
    });

    $('.essentials__image-wrap').hover(function() {
      $( this ).toggleClass('hover');
    });

	});
}



// WEBPACK FOOTER //
// ./scripts/components/SetupAnimations.js